import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieAPIService } from 'src/app/extensions/services/api/cookie-api.service';

@Component({
  selector: 'terms-and-conditions-consent-list',
  templateUrl: './terms-and-conditions-consent-list.component.html',
  styleUrls: ['./terms-and-conditions-consent-list.component.scss'],
  standalone: false,
})
export class TermsAndConditionsConsentListComponent implements OnInit {
  public cookieMessageConsents: app.models.CookieConsentDetailsModel[];
  public cookieMessageId: string;
  public props: app.models.DynamicPropsDictionary;
  public hasNoData = true;
  public subText = '';

  public constructor(
    private _activatedRoute: ActivatedRoute,
    private _cookieAPIService: CookieAPIService,
    private _router: Router
  ) {}

  public ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.cookieMessageId = this._activatedRoute.snapshot.params['cookieId'];
    if (this.cookieMessageId) {
      this._cookieAPIService.getCookieMessageConsents(this.cookieMessageId, '').subscribe(result => {
        this.cookieMessageConsents = result.data;
        this.props = result.props;
        this.hasNoData = this.cookieMessageConsents.length != 0;
      });
    }
  }

  redirectTermsAndConditions() {
    this._router.navigate(['terms-and-conditions']);
  }

  filterConsentList(userNameFilter: string) {
    this._cookieAPIService.getCookieMessageConsents(this.cookieMessageId, userNameFilter).subscribe(result => {
      this.cookieMessageConsents = result.data;
      this.props = result.props;
      this.hasNoData = this.cookieMessageConsents.length != 0;
    });
  }
}
